import { Construction, Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function ComingSoon({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="not-prose">
      <Card className="border-border/70 bg-card">
        <CardContent className="flex flex-col items-center gap-4 px-6 py-12 text-center sm:py-16">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Construction className="h-6 w-6" />
          </div>
          <div className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
              {title}
            </h2>
            <p className="mx-auto max-w-lg text-sm text-muted-foreground sm:text-base">
              {description}
            </p>
          </div>
          <Badge variant="outline" className="gap-1 border-primary/40 bg-primary/10 text-primary">
            <Sparkles className="h-3 w-3" />
            Pregúntale a Faki mientras tanto
          </Badge>
        </CardContent>
      </Card>
    </div>
  );
}
